import {useTranslation} from './localization';
import {publicRoute,publicPath,publicMetadata,publicLocales} from './localization/publicRoutes';
import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import home from './homeMeta.json';
import siteSchema from './siteSchema.json';
import {faqs} from './Landing';

function meta(attribute,name,content){
 let element=document.querySelector('meta['+attribute+'="'+name+'"]');
 if(!element){element=document.createElement('meta');element.setAttribute(attribute,name);document.head.appendChild(element);}
 element.content=content;
}
export default function PageMeta(){
 const {pathname,search}=useLocation();const tr=useTranslation();
 useEffect(()=>{
  const route=publicRoute(pathname),capabilities=/^\/capabilities\/?$/.test(pathname),page=publicMetadata(pathname);
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(node=>node.remove());
  if(route){for(const locale of [...publicLocales,'x-default']){const link=document.createElement('link');link.rel='alternate';link.hreflang=locale;link.href='https://earlybird.live'+publicPath(locale==='x-default'?'en':locale,route.page);document.head.appendChild(link);}}
  document.title=page?.title || (capabilities ? 'EarlyBird job alerts — start your 7-day free trial' : 'Your job alerts | EarlyBird');
  meta('name','robots',page&&!new URLSearchParams(search).has('sessionID')?'index, follow':'noindex, follow');
  meta('name','description',page?.description || 'Sign in to manage your EarlyBird job alerts and subscription.');
  let canonical=document.querySelector('link[rel="canonical"]');
  if(page){
   if(!canonical){canonical=document.createElement('link');canonical.rel='canonical';document.head.appendChild(canonical);}
   canonical.href=page.url;
   for(const [key,value] of Object.entries({title:page.title,description:page.description,url:page.url,type:'website'}))meta('property','og:'+key,value);
   meta('name','twitter:title',page.title);meta('name','twitter:description',page.description);
   meta('property','og:image','https://earlybird.live/earlybird-social.png');
   meta('name','twitter:image','https://earlybird.live/earlybird-social.png');
   meta('name','twitter:card','summary_large_image');
  }else{
   if(capabilities){if(!canonical){canonical=document.createElement('link');canonical.rel='canonical';document.head.appendChild(canonical);}canonical.href='https://earlybird.live/capabilities/';}else canonical?.remove();
   document.querySelectorAll('meta[property^="og:"],meta[name^="twitter:"]').forEach(element=>element.remove());
  }
  // Keep route-specific structured data from being carried into another route.
  document.querySelectorAll('script[type="application/ld+json"]').forEach(element=>element.remove());
  if(page){
   const script=document.createElement('script');script.type='application/ld+json';
   const graph=[...siteSchema['@graph'],{'@type':'WebPage',name:page.title,description:page.description,url:page.url,inLanguage:route.locale,isPartOf:{'@id':home.url+'#website'}}];
   if(route.page==='home')graph.push({'@type':'SoftwareApplication',name:'EarlyBird',url:page.url,applicationCategory:'BusinessApplication',operatingSystem:'Web',description:page.description},{'@type':'FAQPage',mainEntity:faqs.map(([name,text])=>({'@type':'Question',name:tr(name),acceptedAnswer:{'@type':'Answer',text:tr(text)}}))});
   script.textContent=JSON.stringify({'@context':'https://schema.org','@graph':graph});
   document.head.appendChild(script);
  }
 },[pathname,search,tr]);
 useEffect(()=>{if(!window.location.hash)window.scrollTo(0,0);},[pathname,search]);
 return null;
}
